import Vue from "vue";
import Vuex from "vuex";
import shoppingCart from "./shop/modules/shopping-cart";
import giftShoppingCart from "./shop/modules/gift-shopping-cart";
import styles from "./shop/modules/styles";
import user from "./shop/modules/user";
import store from "./shop/modules/storeState";
import logger from "./shop/modules/loggerState";
import PriceTriggerState from "./shop/modules/PriceTriggerState";
import createPersistedState from "vuex-persistedstate";
import menuState from "./shop/modules/menuState";
import surchargeState from "./shop/modules/surchargeState";
import shareCart from "./shop/modules/shareCart";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    shoppingCart,
    giftShoppingCart,
    user,
    store,
    logger,
    PriceTriggerState,
    styles,
    menuState,
    surchargeState,
    shareCart
  },
  plugins: [
    createPersistedState({
      paths: [
        "shoppingCart",
        "giftShoppingCart",
        "store",
        "initLoggerData",
        "styles",
        "PriceTriggerState",
        "user",
        "menuState",
        "surchargeState",
        "shareCart"
      ]
    })
  ],
  strict: debug
});
